export default __webpack_public_path__ + "static/media/8828.9d4c35da.svg";